import PropTypes from 'prop-types';
import { get } from 'lodash';
import cn from "../../../../../utils/cn";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FilterOption = _ref => {
  let {
    id,
    isActive,
    name,
    onChange,
    option
  } = _ref;
  const {
    label
  } = option;
  const filterOptionClass = () => cn({
    'text-sm': true,
    'hover:border-l-2 hover:border-united-blue pl-5 border-solid hover:bg-medium-fill-blue': !option.hasChildren,
    'border-l-2 border-united-blue pl-4': isActive,
    'py-2 px-3 pb-0 uppercase font-heavy-font': option.hasChildren
  });
  if (get(option, 'hasChildren', false)) {
    return /*#__PURE__*/_jsx("div", {
      className: filterOptionClass(),
      children: /*#__PURE__*/_jsx("span", {
        children: label
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: filterOptionClass(),
    "aria-label": label,
    tabIndex: 0,
    children: /*#__PURE__*/_jsxs("label", {
      className: "pt-3 pl-2.5 pb-2.5 text-initial box-content block font-regular-font capitalize tracking-normal",
      htmlFor: id,
      children: [/*#__PURE__*/_jsx("input", {
        checked: isActive === option.value,
        id: id,
        name: name,
        onChange: e => onChange(option, e.target.value),
        type: "radio",
        value: option.value,
        className: "hidden"
      }), /*#__PURE__*/_jsx("span", {
        id: "".concat(id, "-label"),
        children: label
      })]
    })
  });
};
FilterOption.propTypes = {
  id: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  option: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};
export default FilterOption;
//# sourceMappingURL=FilterOption.js.map